import React from "react";
import { connect } from "react-redux";
import { Avatar, Card, Divider } from "antd";
import { Trophy } from "lucide-react";
import { USABLE_ICONS, CORE_VALUE_META, getIcon} from "variables/constants";

const WinnersCard = ({ 
  item,
 }) => {

  const coreValueMeta = CORE_VALUE_META[item?.core_value_name] ?? {};

  const IconComponent =
    coreValueMeta.icon && USABLE_ICONS[coreValueMeta.icon]
      ? USABLE_ICONS[coreValueMeta.icon]
      : null;

  const colorClass = coreValueMeta.color ?? "blue";

  return (
    <Card className={`flex rounded-2xl card-theme ${colorClass} w-full transition-all`}>
      <div className="flex items-start gap-3">
        <div className="relative inline-block">
          <Avatar
            size={64}
            className={`!rounded-full border-4 border-white shadow-lg icon-style ${colorClass} flex items-center justify-center font-normal`}
          >
            {item?.employee_initials}
          </Avatar>

          <div className="absolute -right-1 -bottom-1 w-8 h-8 !rounded-full bg-white shadow-lg border-2 border-white flex items-center justify-center">
            <Trophy className="w-4 h-4 text-amber-500 fill-amber-500" />
          </div>
        </div>

        <div className="flex flex-col">
          <h4 className="font-semibold text-base title-text">
            {item?.employee_name}
          </h4>
          <p className="text-xs muted-text mb-1">{item?.employee_position}</p>
          <p className="text-xs muted-text inline-flex items-center gap-1">
            {getIcon(item?.country_code, "w-4 h-3 rounded-sm")} {item?.employee_country_name}
          </p>
        </div>

        <div
          className={`w-9 h-9 p-2 icon-style ${colorClass} flex items-center justify-center ml-auto self-start`}
        >
          {IconComponent &&
            React.createElement(IconComponent, {
              className: "w-5 h-5 text-white",
            })}
        </div>
      </div>

      <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

      <div className="flex justify-center">
        <span className={`status-indicator ${colorClass} text-xs`}>
          {item?.core_value_name}
        </span>
      </div>

      <p className="text-sm muted-text mt-3">Achievement:</p>
      <p className="text-sm title-text">{item?.cvw_achievement}</p>

      <div className="bg-gradient-to-r from-emerald-50 to-purple-50 rounded-xl p-2 mt-3 border border-emerald-200 dark:from-emerald-900 dark:to-purple-900 dark:border-emerald-700">
        <p className="text-[13px] text-center font-medium text-emerald-700 dark:text-emerald-200">
          🎉 Congratulations! 🎉
        </p>
      </div>
    </Card>
  );
};

const AwardeeCard = ({ recordList }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {recordList?.map((item) => (
        <WinnersCard key={item?.cvw_id} item={item} />
      ))}
    </div>
    
  );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardeeCard);